<div class="left-side-bar" [ngClass]="{ 'left-fliph': clickOnmenu }">
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="collapse navbar-collapse menu-item" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="companylogo-main nav-item dropdownmenu dashboard top-space-fix matmenuiconli">
          <button class="mat-menu-btn" mat-icon-button (click)="ToggleMenu()">
            <mat-icon class="matmenuwhite">menu</mat-icon>
          </button>          
        </li>
        <li class="nav-item dropdownmenu dashboard top-space-fix" *ngIf="CompanyCode != 'chen'"
          [ngClass]="screenlabel == 'dashboard' ? 'active-tab' : ''">
          <a href="/admin/debtronics-dashboard" *ngIf="screenlabel != 'dashboard'" class="left-menu-icon1 icon-space"
            id="clkusermenudashboard"></a>
          <a *ngIf="screenlabel == 'dashboard'" class="left-menu-icon-change icon-space"
            id="clkusermenudashboardactive">
          </a>
          <a href="/admin/debtronics-dashboard"
            class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip" id="clkusermenudashboardnew">
            <span>DashBoard</span></a>
        </li>

        <li class="nav-item dropdownmenu admin" *ngIf="AdminList?.length != 0" [ngClass]="
            screenlabel == 'admincompanymaster' ||
            screenlabel == 'companymaster' ||
            screenlabel == 'usermanagement' ||
            screenlabel == 'reportconfig' ||
            screenlabel == 'parameterconfig' ||
            screenlabel == 'average' ||
            screenlabel == 'graphconfig'
              ? 'active-tab'
              : ''
          ">
          <a *ngIf="
              screenlabel != 'admincompanymaster' &&
              screenlabel != 'companymaster' &&
              screenlabel != 'usermanagement' &&
              screenlabel != 'reportconfig' &&
              screenlabel != 'parameterconfig' &&
              screenlabel != 'average' &&
              screenlabel != 'reportconfig' &&
              screenlabel != 'graphconfig'
            " class="left-menu-icon2 icon-space" id="usermanagement"></a>
          <a *ngIf="
              screenlabel == 'admincompanymaster' ||
              screenlabel == 'companymaster' ||
              screenlabel == 'usermanagement' ||
              screenlabel == 'reportconfig' ||
              screenlabel == 'parameterconfig' ||
              screenlabel == 'average' ||
              screenlabel == 'graphconfig'
            " class="left-menu-icon-change2 icon-space" id="usermanagement"></a>
          <div class="width100">
            <a class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip">Admin
              <span class="mat-select-arrow-wrapper"><img src="assets/images/arrow-white.svg"
                  class="mat-select-arrow-white" id="clkusermenuAdmin" /></span></a>
          </div>
          <div class="dropdown-menu dropdown-hover-menu-data">
            <div *ngFor="let lstadmin of AdminList; let adminIndex = index">
              <a class="dropdown-item" href="{{ ScreenPath[lstadmin.ScreenCode] }}" id="{{ 'AdminList' + adminIndex }}"
                style="font-size: 15px">
                <img id="{{ 'Adminid' + adminIndex }}" src="{{ ImagePath[lstadmin.ScreenCode] }}"
                  style="margin-right: 3px" />
                {{ lstadmin.ScreenName }}</a>
            </div>
          </div>
        </li>

        <li class="nav-item dropdownmenu control" *ngIf="ControlList.length != 0 && CompanyCode != 'chen'" [ngClass]="
            screenlabel == 'control' || screenlabel == 'usercontrol'
              ? 'active-tab'
              : ''
          ">
          <a *ngIf="screenlabel != 'control' && screenlabel != 'usercontrol'" class="left-menu-icon5 icon-space"
            id="control"></a>
          <a *ngIf="screenlabel == 'control' || screenlabel == 'usercontrol'" class="left-menu-icon-change5 icon-space"
            id="control">
          </a>
          <div class="width100">
            <a class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
              id="control_lbl">Control<span class="mat-select-arrow-wrapper"><img src="assets/images/arrow-white.svg"
                  class="mat-select-arrow-white" /></span></a>
          </div>

          <div class="dropdown-menu dropdown-hover-menu-data">
            <div *ngFor="let lstControl of ControlList; let ControlList = index">
              <a class="dropdown-item" href="{{ ScreenPath[lstControl.ScreenCode] }}"
                id="{{ 'ControlList' + ControlList }}" style="font-size: 15px">
                <img class="controlsist" src="{{ ImagePath[lstControl.ScreenCode] }}" style="margin-right: 7px" />{{
                lstControl.ScreenName }}</a>
            </div>
          </div>
        </li>
        <!-- <li
          class="nav-item dropdownmenu dashboard top-space-fix"
          [ngClass]="screenlabel == 'graphs' ? 'active-tab' : ''"
        >
          <a
            href="/common/graphs"
            *ngIf="screenlabel != 'graphs'"
            class="left-menu-view-icon icon-space"
            id="clkusermenudashboardactive"
          ></a>
          <a
            *ngIf="screenlabel == 'graphs'"
            class="left-menu-icon-change-graph icon-space"
            id="clkusermenudashboardnew"
          >
          </a>
          <a
            href="/common/graphs"
            class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
            id="clkusermenudashboardnew"
          >
            <span>View Graph</span></a
          >
        </li> -->
        <li class="nav-item dropdownmenu control" *ngIf="Processlist.length !== 0 && IsForProcesses === 'Y'">
          <a class="left-menu-icon5 icon-space" id="control"></a>
          <div class="width100">
            <a class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
              id="control_lbl">Process<span class="mat-select-arrow-wrapper"><img src="assets/images/arrow-white.svg"
                  class="mat-select-arrow-white" /></span></a>
          </div>
          <div class="dropdown-menu dropdown-hover-menu-data">
            <div *ngFor="let lstControl of Processlist; let Processlist = index">
              <a class="dropdown-item" href="{{ ScreenPath[lstControl.ScreenCode] }}"
                id="{{ 'Processlist' + Processlist }}" style="font-size: 15px">
                <img class="controlsist" src="{{ ImagePath[lstControl.ScreenCode] }}" style="margin-right: 7px" />{{
                lstControl.ScreenName }}
              </a>
            </div>
          </div>
        </li>

        <li class="nav-item dropdownmenu control" *ngIf="ReportList.length != 0">
          <a class="left-menu-icon5 icon-space" id="control"></a>
          <div class="width100">
            <a class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
              id="control_lbl">Report<span class="mat-select-arrow-wrapper"><img src="assets/images/arrow-white.svg"
                  class="mat-select-arrow-white" /></span></a>
          </div>
          <div class="dropdown-menu dropdown-hover-menu-data">
            <div *ngFor="let lstControl of ReportList; let ReportList = index">
              <a class="dropdown-item" href="{{ ScreenPath[lstControl.ScreenCode] }}"
                id="{{ 'ReportList' + ReportList }}" style="font-size: 15px">
                <img class="controlsist" src="{{ ImagePath[lstControl.ScreenCode] }}" style="margin-right: 7px" />{{
                lstControl.ScreenName }}
              </a>
            </div>
          </div>
        </li>

        <li class="nav-item dropdownmenu control" *ngIf="ServiceDetailsList.length != 0">
          <a class="left-menu-icon5 icon-space" id="control"></a>
          <div class="width100">
            <a class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
              id="control_lbl">Report<span class="mat-select-arrow-wrapper"><img src="assets/images/arrow-white.svg"
                  class="mat-select-arrow-white" /></span></a>
          </div>
          <div class="dropdown-menu dropdown-hover-menu-data">
            <div *ngFor="
                let lstControl of ServiceDetailsList;
                let ServiceDetailsList = index
              ">
              <a class="dropdown-item" href="{{ ScreenPath[lstControl.ScreenCode] }}"
                id="{{ 'ServiceDetailsList' + ServiceDetailsList }}" style="font-size: 15px">
                <img class="controlsist" src="{{ ImagePath[lstControl.ScreenCode] }}" style="margin-right: 7px" />{{
                lstControl.ScreenName }}
              </a>
            </div>
          </div>
        </li>
        <li class="nav-item dropdownmenu dashboard top-space-fix" style="padding: 15px 0px 15px 19px"
          *ngIf="this.IsDisplayUserManual == 'Y'" [ngClass]="screenlabel == 'usermanual' ? 'active-tab' : ''">
          <a href="/common/usermanual" *ngIf="screenlabel != 'usermanual'" class="left-menu-user-icon icon-space"
            id="clkusermenudashboardactive">
          </a>
          <a *ngIf="screenlabel == 'usermanual'" class="left-menu-icon-change-manual icon-space"
            id="clkusermenudashboardnew">
          </a>
          <a href="/common/usermanual" class="nav-link text-uppercase font-weight-bold maindash navmenu navmenu-flip"
            id="clkusermenudashboardnew">
            <span>View User Manual</span></a>
        </li>
      </ul>
    </div>
  </nav>
</div>
<!--top header menu start-->
<div class="navbar nav-horizontal">
  <nav class="navbar-expand-lg navbar-light">
    <div>
      <app-loader></app-loader>
    </div>
    <div class="left-sidebar-menu clscompanyname"
      [ngClass]="{ 'marginLeft155 transitionsec': !clickOnmenu && !isbelow813 }">
      <b>{{ CompanyName }}</b>
    </div>
    <div class="right-sidebar-menu">
      <div class="userlogin2 userlogin">
        <div class="userloginimg userloginimg2 cursor-pointer moveleft user-role" id="UsermenuUserimg">
          {{ nameIcon }}
        </div>
        <div class="dropdown-content dropdown-content12">
          <div class="text-center">
            <div class="welcomeuserfont">{{ UserName }}</div>
            <div class="common-fontwel12 cursor-pointer">
              <a href="/common/resetpassword" id="reset_pass">Reset Password</a>
            </div>
            <div class="common-fontwel12 text-underline cursor-pointer" (click)="LogOut()" id="logout">
              Logout
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>

<!--top header menu end-->